<template>
    <ShowControl  @revert="revertClick"  :title="title" ref="showControl">
    <div v-show="market"
         v-loading="lodings"
         style=" width: 80%; margin-top: 3%; height: 90%;overflow-x: hidden;overflow-y: auto;">
      <label style="padding-left: 16px;color: black; display: -webkit-box;    
      -webkit-box-orient: vertical;overflow: hidden;">
        <div>
          本次{{MarketReport.name}}的目标是促进<span style="color: red;">{{ MarketReport.industryNames }}</span>，并为参展企业提供一个专业和吸引人的平台。以下是我们对会展的调研结果和相关费用的详细分析：<br>
          会展场地选择：根据市场调研，我们推荐了以下场地作为较为合适的选择<span style="color: red;">{{ MarketReport.exhibitionVenueNames }}</span>。<br>
          预估费用分析：会展场地总费用：<span style="color: red;">{{MarketReport.siteCost}}元</span>、设计费用：<span style="color: red;">{{MarketReport.feesCost}}元</span>、会场费用：<span style="color: red;">{{MarketReport.otherExpensesCost}}元</span>、
          宣传推广费用：<span style="color: red;">{{MarketReport.publicizeCost}}元</span>、招商费用：<span style="color: red;">{{MarketReport.attractInvestmentCost}}元</span>、媒体费用：<span style="color: red;">{{MarketReport.mediumCost}}元</span>、
          专家差旅费用（<span style="color: red;">{{MarketReport.expertNumber}}位</span>）：<span style="color: red;">{{MarketReport?.expertCost}}元/人</span>、主题演讲费用（<span style="color: red;">{{MarketReport.keynoteMax}}位</span>演讲嘉宾）：<span style="color: red;">{{MarketReport.keynoteCost}}元/人</span>、
          茶点福利（<span style="color: red;">{{MarketReport.teaNumber}}位</span>参展人员）：<span style="color: red;">{{ MarketReport?.teaCost}}元/位</span>、正餐福利（<span style="color: red;">{{MarketReport.dinnerNumber}}桌</span>）：<span style="color: red;">{{ MarketReport?.dinnerCost}}元/桌</span>、
          门票福利（每人<span style="color: red;">{{ MarketReport?.admissionfee}}元</span>）。我们将重点邀请大型企业和龙头企业参与主题招商演讲。同时，展位招商计划设置<span style="color: red;">{{MarketReport.boothAttractNumber}}个</span>，需要邀请对应企业数量<span style="color: red;">（大型企业、中型企业、小型企业）{{ MarketReport.boothEnterprise}} </span>。此外，我们计划设置<span style="color: red;">{{MarketReport.advertisingNumber }}个</span>展会广告位，需要邀请对应企业数量<span style="color: red;">（大型企业、中型企业、小型企业）{{ MarketReport.advertisingEnterprise}} </span>，每个广告位的费用为<span style="color: red;">{{MarketReport.advertisingCosts}}元</span>。
          <br>
          活动安排：本次会展将投放<span style="color: red;">{{MarketReport.activityNumber}}次</span>活动，包括<span style="color: red;">{{MarketReport.activityNames}}</span>。<br>
        </div>
        <el-collapse>
          <el-collapse-item title="详情">
            <div>
            </div>
            <div> {{MarketReport.describe}}</div>
          </el-collapse-item>
        </el-collapse>
      </label>
      <!-- </el-tooltip> -->
      <label style="padding-left: 16px;color: black;">{{
      MarketReport?.marketReportConten
    }}</label><br>
      <div class="item">
        <div class="items"
             id="main1"
             v-if="true">
        </div>
        <div class="items"
             id="main2"
             v-if="true"></div>
      </div>
      <el-row>
        <el-col>
          <el-image :src="
              require('../../../images/previous-page.svg')"
                    @click="btnimg()"
                    style="width: 100px; height: 80px"></el-image>
        </el-col>
      </el-row>
    </div>
    <div v-show="research"  style=" width: 80%; margin-top: 3%;">
      <div class="item">
        <div class="items"
             id="main3"
             v-if="true"></div>
        <div class="items"
             id="main4"
             v-if="true"></div>
      </div>
      <el-row>
        <el-col>
          <el-image :src="
              require('../../../images/previous-page.svg')"
                    @click="btnimgs()"
                    style="width: 100px; height: 80px">
          </el-image>
        </el-col>
      </el-row>
    </div>
  </ShowControl>
</template>

<script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      ChatShow:(state) => state.user.chatShows,
    }),
  },
  components: {
    ShowControl
  },
  data () {
    return {
      MarketReport: {},
      caseID: localStorage.getItem("caseId"),
      flowID: localStorage.getItem("flowID"),
      lodings: false,
      market: true,
      research: false,
      PlatformList: [],
      MediaList: [],
      title: '市场调研分析',
      paltform: {
        title: {
          text: "本市场信息发布(潜在)占比",
          left: "center",
        },
        tooltip: {},
        series: [
          {
            type: "pie",
            radius: "50%",
            data: [],
          },
        ],
      },
      media: {
        title: {
          text: "本市场媒体(潜在)占比",
          left: "center",
        },
        tooltip: {},
        series: [
          {
            type: "pie",
            radius: "50%",
            data: [],
          },
        ],
      },
      customerBudget: {
        title: {
          text: "本市场企业预算(潜在)占比",
          left: "center",
        },
        tooltip: {},
        series: [
          {
            type: "pie",
            radius: "50%",
            data: [],
          },
        ],
      },
      customerNumber: {
        title: {
          text: "本市场企业数量(潜在)占比",
          left: "center",
        },
        tooltip: {},
        series: [
          {
            type: "pie",
            radius: "50%",
            data: [],
          },
        ],
      },
      operates: 0,
    }
  },
  created () {
    //this.GetMarketReport()
    //this.GetMarketList();
  },
  mounted () {
    this.GetMarketList()
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      // this.$router.push("/DataAnalysis")
      this.$router.go(-1)
    },
    btnimg () {
      this.research = true;
      this.market = false;
      this.Getr_MarketReports();
    },
    btnimgs () {
      this.research = false;
      this.market = true;
      this.GetMarketReport();
    },
    GetMarketList () {
      //this.lodings = true;
      this.$http
        .get(`MarketReport/GetPlatformMediaList?CaseID=${this.caseID}`)
        .then((res) => {
          if (res.success) {
            this.PlatformList = res.dynamicObj.platformList;
            this.MediaList = res.dynamicObj.mediaList;
            // let that = this;
            // let operate = that.$store.state.user.operate;
            // if (this.flowID == this.Global.FlowList.策划) {
            //   if ((that.$store.state.user.operate & (1 << 0)) == 0) {
            //     operate += 1;
            //     this.operates = operate
            //     that.$store.commit("operatedepcomit", operate);
            //   }
            // }
            this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.查看市场分析 });  
            this.GetMarketReport();
          }
        });
    },
    Getr_MarketReports () {
      let customerBudgetdata = [];
      let customerBudgets = []
      this.MarketReport.customerBudget.split(',').forEach((rs) => {
        customerBudgets.push(parseInt(rs));
      });
      customerBudgetdata.push({
        name: '大型企业',
        value: customerBudgets[0],
      });
      customerBudgetdata.push({
        name: '中型企业',
        value: customerBudgets[1],
      });
      customerBudgetdata.push({
        name: '小型企业',
        value: customerBudgets[2],
      });
      this.customerBudget.series[0].data = customerBudgetdata;

      let customerNumberdata = [];
      let customerNumbers = []
      this.MarketReport.customerNumber.split(',').forEach((rs) => {
        customerNumbers.push(parseInt(rs));
      });
      customerNumberdata.push({
        name: '大型企业',
        value: customerNumbers[0],
      });
      customerNumberdata.push({
        name: '中型企业',
        value: customerNumbers[1],
      });
      customerNumberdata.push({
        name: '小型企业',
        value: customerNumbers[2],
      });
      this.customerNumber.series[0].data = customerNumberdata;
      this.infos();
    },
    GetMarketReport () {
      this.$http.get(`MarketReport/GetMarketReportDetail?CaseID=${this.caseID}`).then((res) => {
        if (res.success) {
          this.MarketReport = res.dynamicObj
          let paltformdata = [];
          let platformIDs = []
          this.MarketReport.platformID.split(',').forEach((rs) => {
            platformIDs.push(parseInt(rs));
          });
          for (let i = 0; i < platformIDs.length; i++) {
            paltformdata.push({
              name: this.PlatformList.filter(
                (t) => t.id == platformIDs[i]
              )[0]?.name,
              value: this.PlatformList.filter(
                (t) => t.id == platformIDs[i]
              )[0]?.conversionRate,
            });
          }
          this.paltform.series[0].data = paltformdata;

          let mediadata = [];
          let mediaIDs = []
          this.MarketReport.mediaID.split(',').forEach((rs) => {
            mediaIDs.push(parseInt(rs));
          });
          for (let i = 0; i < mediaIDs.length; i++) {
            mediadata.push({
              name: this.MediaList.filter(
                (t) => t.id == mediaIDs[i]
              )[0]?.name,
              value: this.MediaList.filter(
                (t) => t.id == mediaIDs[i]
              )[0]?.conversionRate,
            });
          }
          this.media.series[0].data = mediadata;
          this.info();
        } else {
          return this.$message.error(res.message)
        }
      })
    },
    infos () {
      this.$nextTick(_ => {
        console.log(_)
        var myChart3 = this.echarts.init(document.getElementById("main3"));
        myChart3.clear();
        myChart3.setOption(this.customerBudget);
        window.onresize = function () {
          myChart3.resize();
        };
        var myChart4 = this.echarts.init(document.getElementById("main4"));
        myChart4.clear();
        myChart4.setOption(this.customerNumber);
        window.onresize = function () {
          myChart4.resize();
        };
      })
      //this.lodings = false;
    },
    info () {
      this.$nextTick(_ => {
        console.log(_)
        //初始化时需要加上，确保操作的是最新的DOM
        var chartDom = document.getElementById("main1");
        var myChart1 = this.echarts.init(chartDom);
        myChart1.clear();
        myChart1.setOption(this.paltform);
        window.onresize = function () {
          myChart1.resize();
        };

        var myChart2 = this.echarts.init(document.getElementById("main2"));
        myChart2.clear();
        myChart2.setOption(this.media);
        window.onresize = function () {
          myChart2.resize();
        };
        //this.lodings = false;
      })
    },
  },
  // watch: {
  //   operates (newVal, oldVal) {
  //     if (newVal == 7) {
  //       if (this.flowID == this.Global.FlowList.策划) {
  //         this.$http.get(`User/OperateScore?round=${this.Round}`).then((res) => {
  //           if (res.success) {
  //             let that = this;
  //             let operate = that.$store.state.user.operate;
  //             operate += 1;
  //             this.operates = operate;
  //             that.$store.commit("operatedepcomit", operate);
  //           }
  //         })
  //       }
  //     } else {
  //       console.log(oldVal)
  //     }
  //   }
  // },
}
</script>

<style lang="less" scoped>
#main1 {
  height: 300px;
  width: 50%;
}

#main2 {
  height: 300px;
  width: 50%;
}

#main3 {
  height: 300px;
  width: 50%;
}

#main4 {
  height: 300px;
  width: 50%;
}
.span {
  color: red;
  font-weight: bold;
  font-size: 16px;
}
.tool-tip {
  max-width: 750px;
}
.items {
  display: inline-block;
}
</style>